module.exports = __webpack_public_path__ + "img/image 2.f6c4dcf9.svg";